import { FilterAsyncChip } from 'common/components/FilterChip/FilterAsyncChip';
import { useAtom, WritableAtom } from 'jotai';
import { SetStateAction } from 'react';
import { fetchAccount } from '../Filters/Inputs/accounts/api/accounts';
import { FilterChip } from './FilterChip';

type AccountChipsProps = {
  accountAtom: WritableAtom<(string | null)[], [SetStateAction<(string | null)[]>], void>;
};

export const AccountChips = ({ accountAtom }: AccountChipsProps) => {
  const [accounts, setAccounts] = useAtom(accountAtom);

  const onClear = (id: string | null) => {
    setAccounts((currentAccounts) => currentAccounts.filter((account) => account !== id));
  };

  if (accounts.length === 0) {
    return null;
  }

  return (
    <>
      {accounts.map((account) => {
        if (account === null) {
          return (
            <FilterChip
              key={account}
              text="Account: blank"
              onClose={() => {
                onClear(account);
              }}
            />
          );
        }

        return (
          <FilterAsyncChip
            key={account}
            labelPrefix="Account"
            onCancel={() => {
              onClear(account);
            }}
            fieldName="accountName"
            queryFn={() => {
              return fetchAccount(account);
            }}
            queryKey={['account', account]}
            queryEnabled={!!account}
          />
        );
      })}
    </>
  );
};
